<template>
    <div
        :class="[
            'swiper'
        ]"
    >
        <div
            class="gabarit"
            ref="gabarit"
        >
            <span
                :key="market.id"
                ref="market"
                v-for="(market, i) in data"
                class="caption"
            >
                <a
                    :class="{
                        'router-link-exact-active': i == index
                    }"
                >{{market.name}}</a>
            </span>
        </div>
        <router-link
            :to="$trl({
                name: 'Markets',
                params: {
                    locale: $route.params.locale
                }
            })"
            class="previous"
        >
            <IconArrow
                :direction="'left'"
                :color="'#FFFFFF'"
                width="32"
                height="27"
                class="icon"
            />
        </router-link>
    </div>
</template>
<script>
import Drag from '@/pure/Drag'
import IconArrow from '@/components/IconArrow'
export default {
    components: {
        IconArrow
    },
    props: {
        index: {
            type: Number,
            default: 0
        },
        imageIndex: {
            type: Number,
            default: 0
        },
        data: {
            type: Array,
            default() {return []}
        }
    },
    data() {
        return {

        }
    },
    watch: {
        index(newVal) {
            if(!this.drag.isDragin) {
                this.forceNear(newVal)
            }
        }
    },
    created() {
        this.offset = 0
    },
    mounted() {
        this.handleSize(this.index)
        this.forceNear(this.index)
        this.drag = new Drag({
            element: this.$el,
            onDragCb: this.onDrag,
            onMoveCb: this.onMove,
            onDropCb: this.onDrop,
            onSlideCb: this.onSlide
        })
        window.addEventListener('resize', this.handleSize, false)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleSize)
        this.drag.dispose()
    },
    methods: {
        handleSize(id = null) {
            const winWidth = this.$el.offsetWidth
            this.sizes = this.$refs.market.map(el => {
                const { offsetLeft: left, offsetWidth: width } = el
                return {
                    left: el.offsetLeft,
                    width: el.offsetWidth,
                    offset: (winWidth - width) * .5 - left
                }
            })
            this.forceNear(this.index)
        },
        setOffset(offset) {
            this.offset = offset
            if(this.sizes) {
                offset = Math.max(
                    Math.min(offset, this.sizes[0].offset),
                    this.sizes[this.sizes.length - 1].offset
                )
                this.offset = offset

                this.$refs.gabarit.style.transform = 'translateX(' + offset + 'px)'
                // TweenMax.killTweensOf(this.$refs.gabarit)
                // TweenMax.to(this.$refs.gabarit, .1, {x: offset})
                const near = {
                    id: -1,
                    size: null
                }
                this.sizes.forEach((size, id) => {
                    if(near.id < 0 || Math.abs(size.offset - offset) < Math.abs(near.size.offset - offset)) {
                        near.id = id
                        near.size = size
                    }
                })
                if(near.id !== this.imageIndex) {
                    this.$emit('image-change', near.id)
                }
            }
        },
        forceNear(id) {
            if (id !== null && Number(id) === id && id > -1) {
                // console.log(id)
                this.offset = this.sizes[id].offset
                // TweenMax.killTweensOf(this.$refs.gabarit)
                // TweenMax.to(this.$refs.gabarit, .1, {x: this.offset })
                this.$refs.gabarit.style.transform = 'translateX(' + this.offset + 'px)'

                this.$emit('image-change', id)
            }
        },
        checkNear() {
            const near = {
                id: -1,
                size: null
            }
            this.sizes.forEach((size, id) => {
                if(near.id < 0 || Math.abs(size.offset - this.offset) < Math.abs(near.size.offset - this.offset)) {
                    near.id = id
                    near.size = size
                }
            })
            const veloceX = this.drag.velocity[0]
            const suv = Math.abs(veloceX)
            // console.log(veloceX)
            if(suv > 20) {
                if(veloceX > 0) {
                    this.$emit('previous')
                } else {
                    this.$emit('next')
                }
            }
            else if (near.id !== this.index) {
                this.$emit('index-change', near.id)
            } else {
                this.forceNear(this.index)
            }
        },
        onDrag() {
            this.$el.classList.add('is-drag')
        },
        onSlide() {
            this.$el.classList.remove('is-drag')
            this.$el.classList.add('is-slide')
        },
        onDrop() {
            this.$el.classList.remove('is-drag')
            this.$el.classList.remove('is-slide')
            this.checkNear()
        },
        onMove(x) {
            this.setOffset(this.offset + x)
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.swiper
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    display: flex
    align-items: center
    will-change: transform, opacity
    transition: opacity .3s, transform .625s
    @media print
        position: static
        height: auto
        display: block
        margin-left: 9.6%
        margin-right: 9.6%
    &.v-enter-active,
    &.v-leave-active
        .gabarit
            transition: none
    &.v-enter, &.v-leave-to
        opacity: 0
        transform: translateX(6.25%)
.previous
    $size: 90px
    position: absolute
    bottom: (-$size / 2)
    left: 4.6875%
    width: $size
    height: $size
    background-color: #ff2b2a
    border-radius: 50%
    display: flex
    justify-content: center
    align-items: center
    opacity: 1
    @media print
        display: none
.gabarit
    white-space: nowrap
    will-change: transform
    transition: transform .625s
    display: flex
    align-items: center
    justify-content: center
    .is-drag &
        transition: none
    @media print
        transform: none !important
        display: block

.caption
    color: #ffffff
    font-size: 8.3333333333vw
    font-weight: 500
    margin-left: 0.625em
    margin-right: 0.625em
    letter-spacing: -0.03125em
    // display: inline-block
    // max-width: 80vw
    // min-width: 20vw
    white-space: pre-wrap
    text-align: center
    @include media-breakpoint-up($xxl)
        font-size: 160px
    // @include media-breakpoint-down($hd)
    //     font-size: 100px
    @include media-breakpoint-down($sm)
        font-size: 50px
    @media print
        margin: 0
        color: rgb(255, 43, 43)
    a
        min-width: 40vw
        @include media-breakpoint-down($sm)
            pointer-events: none
        @media print
            min-width: 0
a
    text-decoration: none
    will-change: opacity
    transition: opacity .3s
    display: block
    opacity: .5
    user-select: none
    @media print
        display: none
    &.router-link-exact-active
        opacity: 1
        pointer-events: none
        @media print
            display: inline
.swiper
    cursor: move
    cursor: grab
    &.is-drag
        pointer-events: none
        transition: none
        cursor: grabbing
        .gabarit
            transition: none
        a
            pointer-events: none
    &.is-slide
        transition: none
        .gabarit
            transition: none
</style>
